import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ReportsIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13"><path fillRule="evenodd" d="M13.838.427c-.094-.198-.312-.332-.566-.393-.03-.01-.044-.009-.058-.011a1.194 1.194 0 0 0-.461 0c-.048.005-.052.009-.058.011-.254.061-.472.195-.565.393L10.596 9.02 8.878 4.047c-.094-.199-.312-.333-.567-.393-.029-.01-.04-.008-.053-.01a1.175 1.175 0 0 0-.467 0c-.045.004-.049.008-.055.01-.254.06-.472.194-.566.393L5.482 8.502 3.726 7.067c-.014-.012-.035-.016-.05-.027-.052-.042-.087-.048-.115-.063a1.039 1.039 0 0 0-.174-.075c-.05-.015-.099-.02-.151-.027-.058-.009-.114-.018-.173-.018-.06 0-.114.01-.172.018-.052.008-.102.013-.151.027a.966.966 0 0 0-.174.075c-.03.015-.063.021-.09.04-.042.034-.06.038-.075.05L.278 9.382c-.326.267-.379.86-.086 1.173.294.313.726.266 1.05 0l1.915-2.01 2.079 1.698c.325.267.885.29 1.25.05.038-.023.056-.055.086-.082a.624.624 0 0 0 .144-.178c.01-.016.028-.027.036-.044l1.233-3.253 2.019 5.838c.093.199.311.331.565.393.032.01.046.008.06.01a1.142 1.142 0 0 0 .458 0c.05-.005.053-.008.06-.01.253-.062.47-.195.565-.393l1.677-9.398 1.04 2.04c.159.337.805.455 1.153.257a.862.862 0 0 0 .347-1.077L13.838.427z"/></svg>
        )
    }
}

export default withCssClassName(ReportsIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/reports-icon.js